import * as yup from 'yup';

export const GenerateDocumentInputSchema = yup.object({
  templateId: yup.string().required(),
  residentId: yup.string().required(),
  fileName: yup.string().required(),
  information: yup.string().notRequired().nullable(),
});

export const UpdateGeneratedDocumentSchema = yup.object({
  id: yup.string(),
  information: yup.string().notRequired().nullable(),
});

export const UploadSignedGeneratedDocumentInputSchema = yup.object({
  id: yup.string().required(),
});

export const CreateResidentDocumentGenerationSchema = yup.object({
  templateId: yup.string().required(),
  fileName: yup.string().required(),
  information: yup.string().notRequired().nullable(),
});

export interface ICreateResidentDocumentGeneration {
  templateId: string;
  fileName: string;
  information: string | null;
}

export interface IResidentDocumentGeneration {
  id: string;
  templateId: string;
  information: string | null;
  createdAt: Date;
  fileName: string;
  awsFilePath: string;
  signedFileName: string;
  signedAwsFilePath: string;
}

export const DownloadGeneratedDocumentSchema = yup.object({
  awsFilePath: yup.string().required(),
});

export const DownloadSignedGeneratedDocumentSchema = yup.object({
  signedAwsFilePath: yup.string().required(),
});
